
import { useEffect, useState } from 'react'
import { Form, Table, Tag } from 'antd'
import { URL_BACKEND } from '../../api/url'
import { elToast } from '../../functions/alertas'

const useCorreos = () => {

    // variables
    const [ form ] = Form.useForm()
    // const [cuerpoCorreo, setCuerpoCorreo] = useState("")
    const [valoresForm, setvaloresForm] = useState({})
    const [destinatarios, setDestinatarios] = useState([])
    const [isVisible, setIsVisible] = useState( false )
    const [girando, setGirando] = useState( false )
    const [selectedRowKeys, setSelectedRowKeys] = useState([]);
    const [enviando, setEnviando] = useState( false )
    const [opcionSelect, setOpcionSelect] = useState('')

    const rowSelection = {
        selectedRowKeys,
        onChange: setSelectedRowKeys,
        selections: [
            Table.SELECTION_ALL,
            Table.SELECTION_INVERT,
            Table.SELECTION_NONE
        ],
    };



    // funciones
    const buscarPlantilla = value => {
        setOpcionSelect( value )

        setGirando( true )
        setSelectedRowKeys( [] )

        if ( value.length > 0 ) {

            // eslint-disable-next-line
            if ( value == 'reporte resultados' ) {
                traerAspirantesPendientes()
            } else {
                setDestinatarios( [] )
            }

            let body = new FormData()
            body.append( 'funcion', 'traerPlantilla' )
            body.append( 'tipo', value )

            fetch( URL_BACKEND, {
                method: 'post',
                body
            })
            .then( r => r.json() )
            .then( d => {

                // setCuerpoCorreo( d.cuerpo )
                setvaloresForm( d )

                form.setFieldsValue( d )
            })
            .finally( () => setGirando( false ))

        }

    }

    const traerAspirantesPendientes = () => {

        let body = new FormData()
        body.append( 'funcion', 'listarCorreosReporteResultados' )

        fetch( URL_BACKEND, {
            method: 'post',
            body
        })
        .then( r => r.json() )
        .then( setDestinatarios )

    }

    const enviarCorreos = v => {

        if ( selectedRowKeys.length === 0 ) {
            alert("Debes seleccionar al menos un destinatario")
            setIsVisible( true )
            return
        }

        let enviar = window.confirm( "Confirmación:\n¿Desea enviar correos a los aspirantes?" )

        if ( enviar ) {

            setEnviando( true )

            let body = new FormData()
            body.append( 'funcion', 'enviarCorreoResultados' )
            body.append( 'pk_aspirantes', selectedRowKeys )
            body.append( 'valores', JSON.stringify( v ));

            fetch( URL_BACKEND, {
                method: 'post',
                body
            })
            .then( r => r.json() )
            .then( d => {
                console.log( d );
                // eslint-disable-next-line
                if ( d.codigo == 1 ) {
                    elToast( d.mensaje )
                } else {
                    elToast( d.mensaje, 'error' )
                }
            })
            // .catch( () => {
            //     elToast('Hubo un error al enviar los correos', 'error')
            // })
            .finally( () => {
                setEnviando( false )
            })
        }
    }

    const toggleModal = () => {

        setIsVisible( !isVisible )

    }


    //! borrar
    const verCuantasFilasHay = () => {
        console.log( selectedRowKeys );
    }


    const conteo = () => {

        // if ( selectedRowKeys.length === 0 ) {
        //     return
        // }

        return (
            <p className='lead'>
                Seleccionados { selectedRowKeys.length } de { destinatarios.length }
            </p>
        )

        // esta cosa no sirve porque no hay correos en el selectedRowKeys
        let no_validos = selectedRowKeys.filter( e => {

            if ( !e.includes( '@') ) {
                return e
            }

        })

        if ( no_validos.length > 0 ) {

            return (
                <p className='lead'>
                    Seleccionados { selectedRowKeys.length } de { destinatarios.length }, correos no válidos: { no_validos.length }
                </p>
            )

        } else {

            return (
                <p className='lead'>
                    Seleccionados { selectedRowKeys.length } de { destinatarios.length }, todos válidos
                </p>
            )

        }
    }


    const actualizar = ( campo, valor ) => {

        // eslint-disable-next-line
        if ( opcionSelect == '') {
            return
        }

        let body = new FormData()
        body.append( 'funcion', 'editarCorreo' )
        body.append( 'campo', campo )
        body.append( 'valor', valor )
        body.append( 'opcion_select', opcionSelect )

        fetch( URL_BACKEND, {
            method: 'post',
            body
        })
        .then( r => r.json() )
        .then( d => {
            // console.log( d );
            // eslint-disable-next-line
            if ( d.codigo == 1 ) {
                elToast( d.mensaje )
            } else {
                elToast( d.mensaje, 'error' )
            }
        })
        .catch( () => {
            elToast('Hay problemas al actualizar la plantilla', 'error')
        })
        .finally( () => {
            setEnviando( false )
        })

    }


    // useEffects
    useEffect(() => {

    }, [])





    // useEffect(() => {
    //     form.setFieldsValue({
    //         ...valoresForm
    //     })
    //     console.log( valoresForm );
    // }, [ valoresForm ])


    // tabla
    const columns = [
        {
            title: 'Nombre',
            dataIndex: 'nombre'
        },
        {
            title: 'Correo',
            dataIndex: 'correo',
            render: ( e ) => ( ( !e.includes( '@' ) )  ? <Tag color="volcano">{ e }</Tag> : e )
        },
        {
            title: 'Carrera',
            dataIndex: 'nom_carrera'
        }
    ];



    return {
        buscarPlantilla,
        enviarCorreos,
        form,
        selectedRowKeys,
        setvaloresForm,
        valoresForm,
        destinatarios,
        toggleModal,
        isVisible,
        columns,
        girando,
        rowSelection,
        verCuantasFilasHay,
        conteo,
        enviando,
        actualizar
    }
}

export default useCorreos
